<template>
  <div class="gmf-textarea">
    <textarea ref="textarea" type="text" :rows="rows || 1" :placeholder="placeholder" :value="modelValue || ''"
      @input="onInput" :style="computedStyle" :readonly="readonly" :aria-label="ariaLabel" />
  </div>
</template>

<style>
.gmf-textarea {
  width: 100%;
}
.gmf-textarea textarea {
  background: var(--gmf-input-bg);
  border: none;
  padding: 12px 16px;
  border-radius: var(--gmf-rounding);
  width: 100%;
  font-size: var(--gmf-default-font-size);
  min-height: 80px;
  resize: none;
}
.gmf-textarea textarea::placeholder {
  color: var(--gmf-col-darkgray);
}
</style>

<script>
import getBrowserInfo from '@/utils/tracking';

const info = getBrowserInfo();

const isIOS = info.device.os === 'iOS';

export default {
  props: ['modelValue', 'placeholder', 'rows', 'readonly', 'ariaLabel'],
  
  computed: {
    computedStyle() {
      if (isIOS) {
        return {
          fontSize: '16px',
        }
      }

      return null;
    }
  },

  methods: {
    onInput (evt) {
      this.$emit('update:modelValue', evt.target.value);
      this.autoGrow();
    },
    autoGrow() {
      const el = this.$refs.textarea;
      el.style.height = "5px";
      el.style.height = el.scrollHeight + "px";
    }
  },
  mounted () {
    this.$nextTick(this.autoGrow);
  },
  watch: {
    modelValue () {
      this.autoGrow();
      this.$nextTick(this.autoGrow);
    },
  },
};
</script>
